import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteCarrierAreaContactActions } from 'store/ducks/settings/carrier-area-contact';

export function* deleteCarrierAreaContactRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/carrier/contacts/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteCarrierAreaContactActions.success(data));
    notify('success', 'Contato deletado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteCarrierAreaContactActions.failure(errorMessage));
  }
}
